import React from "react";
import { motion } from "framer-motion";
import { UserRound } from "lucide-react";
import { TEAM } from "./aboData";
import AboLayout, { INK, TEAL, LIGHT, SLATE } from "./AboLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function AboTeam() {
  return (
    <AboLayout active="team">
      <section className="py-16 sm:py-20" style={{ background: INK }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#5EEAD4" }}>Our Team</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 text-3xl sm:text-5xl font-extrabold text-white">The Lawyers</motion.h1>
        </div>
      </section>

      <section>
        <img src="/law/abo-penaranda-law-bgc-concept/team-office.jpg" alt="The Abo & Penaranda team at the BGC office" className="w-full h-56 sm:h-72 object-cover" />
      </section>

      <section className="py-16" style={{ background: LIGHT }}>
        <div className="max-w-5xl mx-auto px-5 sm:px-8 grid sm:grid-cols-2 gap-6">
          {TEAM.map((t, i) => (
            <motion.div key={t.name} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.05 }} className="bg-white rounded-lg shadow-sm overflow-hidden flex">
              {t.photo ? (
                <img src={t.photo} alt={t.name} className="w-32 sm:w-36 object-cover object-top shrink-0" />
              ) : (
                <div className="w-32 sm:w-36 shrink-0 flex items-center justify-center" style={{ background: LIGHT }}>
                  <UserRound size={32} style={{ color: TEAL }} />
                </div>
              )}
              <div className="p-5 flex flex-col justify-center">
                <p className="font-bold" style={{ color: INK }}>{t.name}</p>
                <p className="mt-1 text-xs font-semibold uppercase tracking-wide" style={{ color: TEAL }}>{t.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <motion.p {...fadeUp} className="max-w-5xl mx-auto px-5 sm:px-8 mt-6 text-xs" style={{ color: SLATE }}>The firm's public team pages also list additional junior counsels and support staff; this page shows the currently confirmed leadership.</motion.p>
      </section>
    </AboLayout>
  );
}
